(function() {
	"use strict"

	angular.module( "P3in", [ ] )

})()


// WEBPACK FOOTER //
// ./src/app/modules/P3in/P3in.js